/* eslint-disable react/require-default-props, no-unused-vars */
import React, { useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { string, bool, oneOf } from 'prop-types'
import { doDeleteWebhooks } from 'ducks/webhooks/actions'
import { emptyArr } from 'util/arrays'
import EntityDeleteDrawer from '../EntityDelete'
import WebhookDeleteContent from './Content'

const WebhookDeleteDrawer = props => {
  const {
    queryId = null,
    deleteBtnText = 'Delete',
    open,
    drawerResourceId = '',
    drawerDeleteMode = 'ids',
    onExit,
    onClose,
    onRemove,
  } = props
  const dispatch = useDispatch()

  const ids = useMemo(
    () => {
      return drawerResourceId ? drawerResourceId.split(',') : emptyArr
    },
    [drawerResourceId]
  )

  const handleOnRemove = useCallback(
    () => {
      const response = dispatch(
        doDeleteWebhooks(ids, {
          queryId,
          mode: drawerDeleteMode,
          convertScatterToRaw: true,
        })
      )
      if (onRemove) onRemove()
      return response
    },
    [dispatch, ids, queryId, drawerDeleteMode, onRemove]
  )

  const title =
    drawerDeleteMode === 'query' || ids.length > 1
      ? 'Delete webhooks'
      : 'Delete webhook'

  return (
    <EntityDeleteDrawer
      {...props}
      onRemove={handleOnRemove}
      onClose={onExit}
      tertiaryBtnText="Cancel"
      onCancel={onClose}
      title={title}
      deleteBtnText={deleteBtnText}
      open={open}
    >
      <WebhookDeleteContent
        ids={ids}
        queryId={queryId}
        deleteMode={drawerDeleteMode}
      />
    </EntityDeleteDrawer>
  )
}

WebhookDeleteDrawer.propTypes = {
  deleteBtnText: string,
  open: bool.isRequired,
  drawerDeleteMode: oneOf(['ids', 'query']),
  drawerResourceId: string,
  queryId: string,
}

export default WebhookDeleteDrawer
